module.exports = __webpack_public_path__ + "static/media/news-june-event-david.8442aa52.jpg";